<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'}]">
        <div v-if="isAccountLoaded">
            <AIAHeader
                :modalController="modalController"
                @clickBack="clickBack" />

            <AboutUsCard class="static-content"
                :lblAbout="lbl.about_us"
                :modalController="modalController" />

            <AIAFootMenu
                :pageName="pageName"
                :modalController="modalController" />
        </div>

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//layout
import AIAHeader from "@/components/Layout/header/AIAHeader.vue";
import AIAFootMenu from "@/components/Layout/footer/AIAFootMenu.vue";
//component
import AboutUsCard from "../component/aboutus/AboutUsCard.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
    name: 'AboutUs',
    components: {
        //layout
        AIAHeader,
        AIAFootMenu,
        //component
        AboutUsCard,
        //modal
        ModalMaster
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function () {
        return {
            pageName: 'about',

            trackingService: new TrackingService(this),
            trackingScreenName: 'about_us',
        };
    },
    created: function () {
        this.initialModal();

        this.trackingService.screenName(this.trackingScreenName);
    },
    methods: {
        //event
        clickBack: function () {
            this.$router.back();
        },
        //modal
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
            this.termsModal = modalFactory.getTermsModal();
        },
    }
}
</script>
<style lang="scss">
@import "./Static.scss";
</style>
<style lang="scss" scoped>
</style>
